<template>
  <div id='roleAuth'>
    <!-- 个人信息 -->
    <el-form :inline="true" class="demo-ruleForm" :model="roleRow" ref="roleRow">
      <fieldset style="border-width: 2px; border-color: #990000; width:98%; height:220">
        <!-- <el-row>
          <el-col :span="3" style="padding-top:10px;text-align: right;">
            角色名称
          </el-col>
          <el-col :span="5">
            <el-form-item label="" prop="roleName" id="roleName">
              <el-input :disabled="true" v-model="roleRow.roleName" style="width: 400px;"></el-input>
            </el-form-item>
          </el-col>
        </el-row> -->
        <el-row >
          <el-col :span="16" :offset="4">
            <el-tree
              :data="treeData"
              show-checkbox
              node-key="id"
              ref="tree"
              :default-checked-keys="checkedKey"
              highlight-current
              :props="defaultProps">
            </el-tree>
          </el-col>
        </el-row>
      </fieldset>
    </el-form>

    <!-- 功能按钮 -->
    <el-row style="margin-top:15px">
      <el-col :span="20">&nbsp;
      </el-col>
      <el-col :span="2" v-show="isSave">
        <el-button type="primary" icon="save" @click='save'>保存</el-button>
      </el-col>
    </el-row>
  </div>
</template>
<script>
  export default {
    data() {
      return {
        isSave: true,
        treeData: [],
        defaultProps: {
          children: 'children',
          label: 'name'
        },
        keys: [],
        checkedKey: [],
        halfkeys: []
      }
    },
    mounted: function () {
      this.getMenuList();
      this.getCheckedMenuIds();
    },
    props: ["roleRow"],
    methods: {
      //保存
      save: function () {
        //获取选择的key值
        this.keys = this.$refs.tree.getCheckedKeys();
        this.halfkeys = this.$refs.tree.getHalfCheckedKeys();
        this.$axios.post('/role/roleMenu', {
          "roleId": this.roleRow.id,
          "keys": this.keys,
          "halfkeys": this.halfkeys
        }).then((response) => {
          this.$message({
            message: '授权成功',
            type: 'success'
          });
          this.$emit("closeRole");
        })
      },
      //获取菜单信息
      getMenuList: function () {
        this.$axios.get('/menu/getMenuList').then((response) => {
          this.treeData = response.data;
        })
      },
      //获取选中的菜单
      getCheckedMenuIds: function () {
        this.$axios.get('/role/getCheckedMenuIds?roleId=' + this.roleRow.id).then((response) => {
          var temp = response.data;
          //this.checkedKey=temp;
          this.$refs.tree.setCheckedKeys(temp);
          //this.getCheckedKeys=response.data;
        })
      }
    },
  }
</script>
<style scoped>
  div {
    margin-top: 0px;
  }

  .c {
    margin-top: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/components/role/roleAuth.vue